/** @format */
import { afterRenderEffect, ChangeDetectionStrategy, Component, ElementRef, signal, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationTab } from 'sis-components';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CalendarComponent {
    readonly tabs: NavigationTab[] = [
        {
            path: 'student.logged-in.calendar.not-enrolled',
            title: 'UNSCHEDULED_COURSE_UNITS',
        },
        {
            path: 'student.logged-in.calendar.enrolments',
            title: 'COURSE_UNIT_REALISATIONS',
        },
        {
            path: 'student.logged-in.calendar.aborted-and-finished-enrolments',
            id: 'aborted-finished-enrolments-tab',
            title: 'FINISHED_AND_ABORTED_ENROLMENTS',
        },
    ] as const;

    private rightBarOpenerButton: HTMLElement | null = null;

    protected isRightPanelOpen = signal(false);

    @ViewChild('closeRightBarBtn') closeRightBarBtn: ElementRef<HTMLButtonElement>;

    constructor() {
        afterRenderEffect(() => {
            const isRightBarOpen = this.isRightPanelOpen();

            if (isRightBarOpen) {
                this.closeRightBarBtn?.nativeElement?.focus();
            } else {
                this.rightBarOpenerButton?.focus();
            }
        });
    }

    private toggleRightBar(): void {
        this.isRightPanelOpen.update(prev => !prev);
    }

    protected closeRightBar(): void {
        this.toggleRightBar();
    }

    protected handleToggleRightBar(openerBtn: HTMLElement): void {
        this.rightBarOpenerButton = openerBtn;
        this.toggleRightBar();
    }
}
